
import _ from "lodash"
import { getDisplayProjectValue, getRelativeTimingMessage, getRelativeUpdatedMessage } from "../../../utils"
import { convertDate, fetchSortLabel } from "../../../utils/commonFunctions"
import { updateNoResult } from "../../myleads/reducer"
import { toggleBuildPhaseFilter, toggleCalendarTimingFilter, toggleEndConstructionFilter, toggleFilterActiveState, toggleLastUpdatedFilter, toggleNewUpdatedFilter, toggleRoleAddedFilter, toggleStartConstructionFilter, updateAdvanceLocation, updateBuildPhaseValueReducer, updateCalenderEndFrom, updateCalenderEndTo, updateCalenderStartFrom, updateCalenderStartTo, updateCategoryLandTypeFilter, updateCategoryUsageTypeFilter, updateEndConstructionFilter, updateExcludeStageFilter, updateFilterText, updateLastUpdatedFilter, updateMeasures, updateNewPublishFilter, updatePrimaryCategoriesOnlyFlag, updateProjectFramework, updateRoleAddedFilter, updateSavedSearchCheckboxFilters, updateSelectedSearchType, updateShowCompletedChecked, updateSort, updateStartConstructionFilter, updateValue } from "../../search/filters/redux/reducer"
import { fetchSearchListForAllObjectType, rolesForProject, updateArchiveSearchList, updateIdsForShowRelatedEntities, updatelistOfSelectedObjectIds, updateMaxApiCalls, updateNavigationBack, updateObjectData, updateObjectId, updatePeopleProjectsList, updateProjectsForCompanyId, updateSearchLoader, updateSelectedSelectorControlValue, updateShowHierarchy, updateShowSelectedCompanies, updateShowSelectedProjects,updateIsShowProjectsOrCompanySelected } from "../../search/redux/reducer"
import { updateAppliedContext, updatedSelectedSavedSearch, updateSaveSeachRedirectionApplied, updateSortSearch } from "../../search/redux/searchPeristReducer"
import { ConeStriped } from "react-bootstrap-icons"


export function initializeSavedSearchFilterState(savedSearch, searchPersist, filter, dispatch) {
    let defaultFilters = filter.defaultFilter[savedSearch?.object_type]
    initializeSaveSearchContext(dispatch, savedSearch)

    initializeProjectInformation(savedSearch, dispatch)
    initializePersonInformation(savedSearch, dispatch)
    initializePostcodeFilter(savedSearch, dispatch)
    initializeTownCodeFilter(savedSearch, dispatch)
    initializeProjectlocationFilter(savedSearch, dispatch)
    initializeCompanylocationFilter(savedSearch, dispatch)
    initializeProjectFramework(savedSearch, searchPersist, dispatch)
    initializeProjectTitle(savedSearch, dispatch)
    initializeProjectScheme(savedSearch, dispatch)
    initializeCompanyInfo(savedSearch, dispatch)
    initializeCompanyName(savedSearch, dispatch)
    initializeCompanyId(savedSearch, dispatch)
    initializeCompanyTownCodeFilter(savedSearch, dispatch)
    initializeCompanyPostCodeFilter(savedSearch, dispatch)
    initializeValue(savedSearch, dispatch)
    initializeCalenderStartDate(savedSearch, defaultFilters, dispatch)
    initializeCalenderEndDate(savedSearch, defaultFilters, dispatch)
    initializeUpdated(savedSearch, dispatch)
    initializeProjectRegion(savedSearch, defaultFilters, dispatch)
    initializeCompanyRegion(savedSearch, defaultFilters, dispatch)
    initializeBuildPhase(savedSearch, dispatch)
    initializeBrandInformation(savedSearch, dispatch)
    initializeMaterials(savedSearch, defaultFilters, dispatch)
    initializeCategories(savedSearch, defaultFilters, dispatch)
    initializeDevTypes(savedSearch, defaultFilters, dispatch)
    initializeRoles(savedSearch, defaultFilters, dispatch)
    initializeStages(savedSearch, defaultFilters, dispatch)
    initializeMeasures(savedSearch, dispatch)
    initializeProjectUsuage(savedSearch, dispatch)
    initializeCategoryLandType(savedSearch, dispatch)
    initializeSort(savedSearch, dispatch, searchPersist)

}

const initializeSort = (savedSearch, dispatch, searchPersist) => {
    let updatedSortOrderObj = _.cloneDeep(searchPersist.defaultSort);
    let sort = ''
    if ('sort' in savedSearch) {
        sort = savedSearch.sort
    } else {
        let query = savedSearch.query
        sort = (query && (query.project_text || query.project_title || query.project_scheme
            || query.company_text || query.company_name || query.company_id
            || query.person_text || query.person_full_name || query.person_job_title)) ? '' :
            (savedSearch.object_type === 'people') ? 'person_first_name,person_last_name' : savedSearch.object_type === "company" ? "-count_project_id" : "-project_last_published"
    }
    updatedSortOrderObj[savedSearch?.object_type] = {
        label: fetchSortLabel(sort),
        value: sort,
    };
    dispatch(updateSortSearch(updatedSortOrderObj));
    dispatch(updateSort(sort))
}

const initializeProjectInformation = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_text) {
        let payload1 = {
            value: savedSearch?.query?.project_text?.value,
            dataObj: savedSearch?.query?.project_text?.value,
            active: savedSearch?.query?.project_text.value?.length > 0 ? true : false,
            keyname: "projectInformation",
            isAnyAll: savedSearch?.project_search ? savedSearch?.project_search : "any"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializePersonInformation = (savedSearch, dispatch) => {
    if (savedSearch?.query?.person_text) {
        let payload1 = {
            value: savedSearch?.query?.person_text.value,
            dataObj: savedSearch?.query?.person_text.value,
            active: savedSearch?.query?.person_text.value !== '' ? true : false,
            keyname: "personInformation"
        }
        dispatch(updateFilterText(payload1))
    }
    if (savedSearch?.query?.person_full_name) {
        let payload1 = {
            value: savedSearch?.query?.person_full_name.value,
            dataObj: savedSearch?.query?.person_full_name.value,
            active: savedSearch?.query?.person_full_name.value !== '' ? true : false,
            keyname: "personName"
        }
        dispatch(updateFilterText(payload1))
    }

    if (savedSearch?.query?.person_job_title) {
        let payload1 = {
            value: savedSearch?.query?.person_job_title.value,
            dataObj: savedSearch?.query?.person_job_title.value,
            active: savedSearch?.query?.person_job_title.value !== '' ? true : false,
            keyname: "personJobTitle"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializePostcodeFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_postcode) {
        let payload = {
            value: savedSearch?.query?.project_postcode?.value,
            dataObj: savedSearch?.query?.project_postcode?.value,
            active: savedSearch?.query?.project_postcode?.value.length > 0 ? true : false,
            keyname: "projectPostcode"
        }
        dispatch(updateFilterText(payload))
    }
}

const initializeTownCodeFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_town) {
        let payload = {
            value: savedSearch?.query?.project_town?.value,
            dataObj: savedSearch?.query?.project_town?.value,
            active: savedSearch?.query?.project_town?.value.length > 0 ? true : false,
            keyname: "projectTown"
        }
        dispatch(updateFilterText(payload))
    }
}

const initializeProjectlocationFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_distance?.value) {
        var locationData = {}
        if (savedSearch?.project_location_display) {
            locationData = {
                location: savedSearch?.project_location_display,
                latitude: savedSearch?.query?.project_latitude?.value,
                longitude: savedSearch?.query?.project_longitude?.value,
                radius: savedSearch?.query?.project_distance?.value,
                active: true,
                keyname: "location"
            }
        } else if (savedSearch?.project_current_location) {
            locationData = {
                location: 'Current Location',
                latitude: savedSearch?.query?.project_latitude?.value,
                longitude: savedSearch?.query?.project_longitude?.value,
                radius: savedSearch?.query?.project_distance?.value,
                active: true,
                keyname: "location"
            }
        } else {
            locationData = {
                location: 'Dropped pin',
                latitude: savedSearch?.query?.project_latitude?.value,
                longitude: savedSearch?.query?.project_longitude?.value,
                radius: savedSearch?.query?.project_distance?.value,
                active: true,
                keyname: "location"
            }
        }
        dispatch(updateAdvanceLocation(locationData))
    }
}

const initializeCompanylocationFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_distance?.value) {
        var locationData = {}
        if (savedSearch?.company_location_display) {
            locationData = {
                location: savedSearch?.company_location_display,
                latitude: savedSearch?.query?.company_latitude?.value,
                longitude: savedSearch?.query?.company_longitude?.value,
                radius: savedSearch?.query?.company_distance?.value,
                active: true,
                keyname: "companyLocation"
            }
        } else if (savedSearch?.company_current_location) {
            locationData = {
                location: 'Current Location',
                latitude: savedSearch?.query?.company_latitude?.value,
                longitude: savedSearch?.query?.company_longitude?.value,
                radius: savedSearch?.query?.company_distance?.value,
                active: true,
                keyname: "companyLocation"
            }
        } else {
            locationData = {
                location: 'Dropped pin',
                latitude: savedSearch?.query?.company_latitude?.value,
                longitude: savedSearch?.query?.company_longitude?.value,
                radius: savedSearch?.query?.company_distance?.value,
                active: true,
                keyname: "companyLocation"
            }
        }
        dispatch(updateAdvanceLocation(locationData))
    }
}
const initializeProjectFramework = (savedSearch, searchPersist, dispatch) => {
    if (savedSearch?.query?.project_framework) {
        let frameworkArray = []
        searchPersist?.frameworkList.filter(item => savedSearch?.query?.project_framework?.value.includes(item.id)).map(item =>
            frameworkArray.push({ id: item.id, name: item.description }))
        let frameworkdata = {
            value: savedSearch?.query?.project_framework?.value,
            dataObj: frameworkArray,
            active: true,
            keyname: "projectFramework"
        }
        dispatch(updateProjectFramework(frameworkdata))
    }
}

const initializeProjectTitle = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_title) {
        let payload1 = {
            value: savedSearch?.query?.project_title.value,
            dataObj: savedSearch?.query?.project_title.value,
            active: savedSearch?.query?.project_title.value !== '' ? true : false,
            keyname: "projectTitle"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializeProjectScheme = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_scheme) {
        let payload1 = {
            value: savedSearch?.query?.project_scheme?.value,
            dataObj: savedSearch?.query?.project_scheme?.value,
            active: savedSearch?.query?.project_scheme?.value !== '' ? true : false,
            keyname: "projectScheme"
        }
        dispatch(updateFilterText(payload1))
    }
}
const initializeCompanyInfo = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_text) {
        let payload1 = {
            value: savedSearch?.query?.company_text?.value,
            dataObj: savedSearch?.query?.company_text?.value,
            active: savedSearch?.query?.company_text?.value !== '' ? true : false,
            keyname: "companyInformation"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializeCompanyName = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_name) {
        let payload1 = {
            value: savedSearch?.query?.company_name?.value,
            dataObj: savedSearch?.query?.company_name?.value,
            active: savedSearch?.query?.company_name?.value !== '' ? true : false,
            keyname: "companyName"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializeCompanyId = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_id) {
        let payload1 = {
            value: savedSearch?.query?.company_id?.value,
            dataObj: savedSearch?.query?.company_id?.value,
            active: savedSearch?.query?.company_id?.value !== '' ? true : false,
            keyname: "companyId"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializeCompanyTownCodeFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_town) {
        let payload = {
            value: savedSearch?.query?.company_town?.value,
            dataObj: savedSearch?.query?.company_town?.value,
            active: savedSearch?.query?.company_town?.value.length > 0 ? true : false,
            keyname: "companyTown"
        }
        dispatch(updateFilterText(payload))
    }
}
const initializeCompanyPostCodeFilter = (savedSearch, dispatch) => {
    if (savedSearch?.query?.company_postcode) {
        let payload = {
            value: savedSearch?.query?.company_postcode?.value,
            dataObj: savedSearch?.query?.company_postcode?.value,
            active: savedSearch?.query?.company_postcode?.value.length > 0 ? true : false,
            keyname: "companyPostcode"
        }
        dispatch(updateFilterText(payload))
    }
}

const initializeValue = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_value) {
        let fromValue = savedSearch.query.project_value.value1 ? savedSearch.query.project_value.value1 : savedSearch?.query?.project_value?.operator === ">=" ? savedSearch?.query?.project_value.value : null
        let toValue = savedSearch.query.project_value.value2 ? savedSearch.query.project_value.value2 : savedSearch?.query?.project_value?.operator === "<=" ? savedSearch?.query?.project_value.value : null
        let value1 = savedSearch?.query?.project_value?.operator === ".." ? getDisplayProjectValue(savedSearch.query.project_value.value1) : savedSearch?.query?.project_value?.operator === "<=" ? "" : getDisplayProjectValue(savedSearch?.query?.project_value.value)
        let value2 = savedSearch?.query?.project_value?.operator === ".." ? getDisplayProjectValue(savedSearch.query.project_value.value2) : savedSearch?.query?.project_value?.operator === ">=" ? "" : getDisplayProjectValue(savedSearch?.query?.project_value.value)
        let payload = {
            from: fromValue,
            to: toValue,
            displayFrom: value1,
            displayTo: value2,
            active: value1 || value2 ? true : false,
            keyname: "Value"
        }
        dispatch(updateValue(payload))
    }
}

const initializeCalenderStartDate = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_start) {
        if (savedSearch?.query?.project_start?.operator === "..") {
            if (typeof savedSearch?.query?.project_start.value1 === 'number') {
                let value1 = savedSearch?.query?.project_start.value1 > 0 ? '+' + savedSearch?.query?.project_start.value1.toString() : savedSearch?.query?.project_start.value1.toString()
                let startConstruction1 = stateDefaultFilter.startConstruction.options.filter(item => item.value === value1).map(item => item.name)
                let value2 = savedSearch?.query?.project_start.value2 > 0 ? '+' + savedSearch?.query?.project_start.value2.toString() : savedSearch?.query?.project_start.value2.toString()
                let startConstruction2 = stateDefaultFilter.startConstruction.options.filter(item => item.value === value2).map(item => item.name)
                dispatch(toggleStartConstructionFilter(true))
                dispatch(updateStartConstructionFilter([startConstruction1[0], startConstruction2[0]]))
            } else {
                let date = convertDate(savedSearch?.query?.project_start.value1)
                let date1 = convertDate(savedSearch?.query?.project_start.value2)
                dispatch(updateCalenderStartFrom(date))
                dispatch(toggleCalendarTimingFilter(true))
                dispatch(updateCalenderStartTo(date1))
            }
        }
        else if (savedSearch?.query?.project_start?.operator === ">=") {
            let date = convertDate(savedSearch?.query?.project_start.value)
            dispatch(updateCalenderStartFrom(date))
            dispatch(toggleCalendarTimingFilter(true))
        }
        else if (savedSearch?.query?.project_start?.operator === "<=") {
            let date = convertDate(savedSearch?.query?.project_start.value)
            dispatch(updateCalenderStartTo(date))
        }
    }
}

const initializeCalenderEndDate = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_finish) {
        if (savedSearch?.query?.project_finish?.operator === "..") {
            if (typeof savedSearch?.query?.project_finish.value1 === 'number') {
                let value1 = savedSearch?.query?.project_finish.value1 > 0 ? '+' + savedSearch?.query?.project_finish.value1.toString() : savedSearch?.query?.project_finish.value1.toString()
                let endConstruction1 = stateDefaultFilter.startConstruction.options.filter(item => item.value === value1).map(item => item.name)
                let value2 = savedSearch?.query?.project_finish.value2 > 0 ? '+' + savedSearch?.query?.project_finish.value2.toString() : savedSearch?.query?.project_finish.value2.toString()
                let endConstruction2 = stateDefaultFilter.startConstruction.options.filter(item => item.value === value2).map(item => item.name)
                dispatch(toggleEndConstructionFilter(true))
                dispatch(updateEndConstructionFilter([endConstruction1[0], endConstruction2[0]]))
            } else {
                let date = convertDate(savedSearch?.query?.project_finish.value1)
                let date1 = convertDate(savedSearch?.query?.project_finish.value2)
                dispatch(updateCalenderEndFrom(date))
                dispatch(toggleCalendarTimingFilter(true))
                dispatch(updateCalenderEndTo(date1))
            }
        }
        else if (savedSearch?.query?.project_finish?.operator === "<=") {
            let date = convertDate(savedSearch?.query?.project_finish.value)
            dispatch(updateCalenderEndFrom(date))
        }
        else if (savedSearch?.query?.project_finish?.operator === ">=") {
            let date = convertDate(savedSearch?.query?.project_finish.value)
            dispatch(updateCalenderEndTo(date))
        }
    }
}

const initializeUpdated = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_is_new || savedSearch?.query?.project_last_published) {
        if (savedSearch?.query?.project_is_new?.value === undefined) {
            dispatch(toggleFilterActiveState({ key: "updated", value: true }))
            dispatch(toggleFilterActiveState({ key: "new", value: true }))
            dispatch(toggleNewUpdatedFilter(true))
            dispatch(toggleLastUpdatedFilter(true))
            let msg = "in the last" + getRelativeUpdatedMessage(savedSearch?.query?.project_last_published?.value1)
            dispatch(updateNewPublishFilter(msg));
            dispatch(updateLastUpdatedFilter(msg));
        } else if (savedSearch?.query?.project_is_new?.value === true) {
            dispatch(toggleFilterActiveState({ key: "new", value: true }))
            dispatch(toggleNewUpdatedFilter(true))
            let msg = "in the last" + getRelativeUpdatedMessage(savedSearch?.query?.project_last_published?.value1)
            dispatch(updateNewPublishFilter(msg));
        } else {
            dispatch(toggleFilterActiveState({ key: "updated", value: true }))
            dispatch(toggleLastUpdatedFilter(true))
            let msg = "in the last" + getRelativeUpdatedMessage(savedSearch?.query?.project_last_published?.value1)
            dispatch(updateLastUpdatedFilter(msg));
        }
    }
}

const initializeProjectRegion = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_geocode) {
        let regions = updateSaveSearchItemsFilter({ regions: stateDefaultFilter.regions }, { regions: savedSearch?.query?.project_geocode.value }, 'regions', 'counties')
        dispatch(updateSavedSearchCheckboxFilters({ value: regions, title: regions.title }))

    }
}

const initializeCompanyRegion = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.company_geocode) {
        let companyRegions = updateSaveSearchItemsFilter({ companyRegions: stateDefaultFilter.companyRegions }, { companyRegions: savedSearch?.query?.company_geocode.value }, 'companyRegions', 'counties')
        dispatch(updateSavedSearchCheckboxFilters({ value: companyRegions, title: companyRegions.title }))
    }
}

const initializeCategories = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_categories || savedSearch?.query?.project_primary_category) {
        let categories = savedSearch?.query?.project_categories ? savedSearch?.query?.project_categories : savedSearch?.query?.project_primary_category;
        _.map(categories, (i) => {
            if (i.operator === "=") {
                let primaryCategoriesOnly = Boolean(savedSearch?.query?.project_primary_category)
                dispatch(updatePrimaryCategoriesOnlyFlag(primaryCategoriesOnly))
                let includeCategories = updateSaveSearchItemsFilter(stateDefaultFilter, { includeCategories: i.value }, 'includeCategories', 'subCategories')
                dispatch(updateSavedSearchCheckboxFilters({ value: includeCategories, title: includeCategories.title }))
            } else {
                let primaryCategoriesOnly = Boolean(savedSearch?.query?.project_primary_category)
                dispatch(updatePrimaryCategoriesOnlyFlag(primaryCategoriesOnly))
                let excludeCategories = updateSaveSearchItemsFilter(stateDefaultFilter, { excludeCategories: i.value }, 'excludeCategories', 'subCategories')
                dispatch(updateSavedSearchCheckboxFilters({ value: excludeCategories, title: excludeCategories.title }))
            }
        })
    }
}

const initializeDevTypes = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_development_types) {
        _.map(savedSearch?.query?.project_development_types, (i) => {
            if (i.operator === "=") {
                let includeDevelopmentTypes = updateSaveSearchItemsFilter(stateDefaultFilter, { includeDevelopmentTypes: i.value }, 'includeDevelopmentTypes', null)
                includeDevelopmentTypes.active = true
                dispatch(updateSavedSearchCheckboxFilters({ value: includeDevelopmentTypes, title: includeDevelopmentTypes.title }))
            } else {
                let excludeDevelopmentTypes = updateSaveSearchItemsFilter(stateDefaultFilter, { excludeDevelopmentTypes: i.value }, 'excludeDevelopmentTypes', null)
                excludeDevelopmentTypes.active = true
                dispatch(updateSavedSearchCheckboxFilters({ value: excludeDevelopmentTypes, title: excludeDevelopmentTypes.title }))
            }
        })
    }
}

const initializeStages = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_stages) {
        _.map(savedSearch?.query?.project_stages, (i) => {
            if (i.operator === "=") {
                let stagesArr = i.value
                let includeStages = updateSaveSearchArrayFilter(stateDefaultFilter, { includeStages: stagesArr }, 'includeStages')
                includeStages = updateParentStages(includeStages, stagesArr)
                dispatch(updateSavedSearchCheckboxFilters({ value: includeStages, title: includeStages.title }))
            } else if (i.operator === "!=") {
                let exStages = [19, 20]
                let stagesArr = i.value
                if (exStages.every(item => !stagesArr.includes(item))) {
                    let excludeStages = _.cloneDeep(stateDefaultFilter.excludeStages)
                    excludeStages.active = true
                    excludeStages.toggleActive = true
                    dispatch(updateSavedSearchCheckboxFilters({ value: excludeStages, title: excludeStages.title }))
                }
                exStages = i.value.filter(stage => !exStages.includes(stage))
                if (exStages.length > 0) {
                    let advanceExcludeStages = updateSaveSearchArrayFilter(stateDefaultFilter, { advanceExcludeStages: exStages }, 'advanceExcludeStages')
                    advanceExcludeStages = updateParentStages(advanceExcludeStages, exStages)
                    dispatch(updateSavedSearchCheckboxFilters({ value: advanceExcludeStages, title: 'advanceExcludeStages' }))
                }
            } else {
                dispatch(updateExcludeStageFilter({ name: 'excludeStages', active: true }))
            }
        })
    } else {
        dispatch(updateExcludeStageFilter({ name: 'excludeStages', active: true }))
    }
}

const initializeBuildPhase = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_build_phase) {
        updateBuildPhase(savedSearch.query.project_build_phase.value, dispatch)
        updateCompletedProject(savedSearch.query.project_build_phase.value, dispatch)
    }
}

const initializeBrandInformation = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_brands) {
        let payload1 = {
            value: savedSearch?.query?.project_brands?.value,
            dataObj: savedSearch?.query?.project_brands?.value,
            active: savedSearch?.query?.project_brands.value?.length > 0 ? true : false,
            keyname: "brands"
        }
        dispatch(updateFilterText(payload1))
    }
}

const initializeMaterials = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_materials) {
        let materials = updateFilterRecursively(stateDefaultFilter, { material: savedSearch?.query?.project_materials.value }, 'materials')
        dispatch(updateSavedSearchCheckboxFilters({ value: materials, title: materials.title }))
    }
}

const initializeMeasures = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_units) {
        updateMeasure('noOfUnits', savedSearch?.query?.project_units, dispatch)
    }
    if (savedSearch?.query?.project_storeys_above) {
        updateMeasure('aboveGroundStoreys', savedSearch?.query?.project_storeys_above, dispatch)
    }
    if (savedSearch?.query?.project_storeys_below) {
        updateMeasure('belowGroundStoreys', savedSearch?.query?.project_storeys_below, dispatch)
    }
    if (savedSearch?.query?.project_site_area) {
        updateMeasure('siteArea', savedSearch?.query?.project_site_area, dispatch)
    }
    if (savedSearch?.query?.project_floor_area) {
        updateMeasure('groundFloorArea', savedSearch?.query?.project_floor_area, dispatch)
    }
    if (savedSearch?.query?.project_plan_area) {
        updateMeasure('totalFloorArea', savedSearch?.query?.project_plan_area, dispatch)
    }
    if (savedSearch?.query?.project_parking) {
        updateMeasure('parkingSpaces', savedSearch?.query?.project_parking, dispatch)
    }
}

const initializeProjectUsuage = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_usage) {
        if (savedSearch?.query?.project_usage?.value?.length > 0) {
            _.map(savedSearch?.query?.project_usage?.value, (i) => {
                let payload = {
                    isSelected: true,
                    value: i,
                }
                dispatch(updateCategoryUsageTypeFilter(payload))
            })
        }

    }
}
const initializeCategoryLandType = (savedSearch, dispatch) => {
    if (savedSearch?.query?.project_land_type) {
        if (savedSearch?.query?.project_land_type?.value?.length > 0) {
            _.map(savedSearch?.query?.project_land_type?.value, (i) => {
                let payload = {
                    isSelected: true,
                    value: i,
                }
                dispatch(updateCategoryLandTypeFilter(payload))
            })
        }

    }

}

const initializeRoles = (savedSearch, stateDefaultFilter, dispatch) => {
    if (savedSearch?.query?.project_roles && !savedSearch?.query?.role_updated) {
        _.map(savedSearch?.query?.project_roles, (i) => {
            if (i.operator === "=") {
                let includeRoles = updateSaveSearchRoleFilter(stateDefaultFilter, { includeRoles: i.value }, 'includeRoles')
                dispatch(updateSavedSearchCheckboxFilters({ value: includeRoles, title: includeRoles.title }))
            } else {
                let excludeRoles = updateSaveSearchRoleFilter(stateDefaultFilter, { excludeRoles: i.value }, 'excludeRoles')
                dispatch(updateSavedSearchCheckboxFilters({ value: excludeRoles, title: excludeRoles.title }))
            }
        })
    }

    if (savedSearch?.query?.role_code && savedSearch?.query?.role_updated) {
        _.map(savedSearch?.query?.role_code, (i) => {
            if (i.operator === "=") {
                let includeRoles = updateSaveSearchRoleFilter(stateDefaultFilter, { includeRoles: i.value }, 'includeRoles')
                dispatch(updateSavedSearchCheckboxFilters({ value: includeRoles, title: includeRoles.title }))
            } else {
                let excludeRoles = updateSaveSearchRoleFilter(stateDefaultFilter, { excludeRoles: i.value }, 'excludeRoles')
                dispatch(updateSavedSearchCheckboxFilters({ value: excludeRoles, title: excludeRoles.title }))
            }
        })
        dispatch(toggleFilterActiveState({ key: "roleAdded", value: true }))
        dispatch(toggleRoleAddedFilter(true))
        let msg = getRelativeTimingMessage(savedSearch.query.role_updated?.value1)
        dispatch(updateRoleAddedFilter(msg.trim()))
    }
}

function initializeSaveSearchContext(dispatch, savedSearch) {
    dispatch(updateSelectedSearchType(savedSearch?.object_type))
    dispatch(updateAppliedContext(savedSearch?.object_type))
    dispatch(updatedSelectedSavedSearch(savedSearch))
    dispatch(fetchSearchListForAllObjectType({ leadsFlags: [], count: 0, filterType: savedSearch?.object_type }))
    dispatch(updateSearchLoader(true))
    dispatch(updateNoResult(true))
    dispatch(updateMaxApiCalls(0))
    dispatch(updateArchiveSearchList(true))
    dispatch(updateIdsForShowRelatedEntities([]));
    dispatch(updateSelectedSelectorControlValue(0));
    dispatch(rolesForProject([]));
    dispatch(updatePeopleProjectsList([]));
    dispatch(updateProjectsForCompanyId([]));
    dispatch(updateShowHierarchy({ showProjectHierarchy: false, showCompanyHierarchy: false }))
    dispatch(updateObjectData(undefined))
    dispatch(updateNavigationBack(''))
    dispatch(updateShowSelectedCompanies(false));
    dispatch(updateShowSelectedProjects(false));
    dispatch(updateIsShowProjectsOrCompanySelected(false))
    dispatch(updatelistOfSelectedObjectIds({ leadsFlags: [], count: 0 }));
    dispatch(updateObjectId(undefined));
}

function updateCompletedProject(buildPhaseValue, dispatch) {
    if (buildPhaseValue.includes("completed")) {
        dispatch(updateShowCompletedChecked(true))
    }
}

function updateBuildPhase(buildPhaseValue, dispatch) {
    if (!buildPhaseValue.includes("no_timing")) {
        let sliderValue = isExactMatch(['not_started'], buildPhaseValue) ? [0, 1]
            : isExactMatch(['on_site'], buildPhaseValue) ? [2, 3]
                : isExactMatch(['enabling'], buildPhaseValue) ? [1, 2]
                    : isExactMatch(['enabling', 'on_site'], buildPhaseValue) ? [1, 3]
                        : isExactMatch(['not_started', 'enabling'], buildPhaseValue) ? [0, 2]
                            : [0, 3]
        dispatch(toggleBuildPhaseFilter(true))
        dispatch(updateBuildPhaseValueReducer({ activePhase: buildPhaseValue, sliderValue: sliderValue }))
    }
}

// Function to check if arr1 is an exact match in arr2
const isExactMatch = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    return arr1.every((element, index) => element === arr2[index]);
};

function updateSaveSearchItemsFilter(stateDefaultFilter, savedSearchProfile, filterName, child) {
    let filter = _.cloneDeep(stateDefaultFilter[filterName])
    let filteredList = []
    filter.options.map(function (option) {
        let parsedOptionValue = ''
        if ((filterName === "regions" || filterName === "companyRegions")) {
            parsedOptionValue = option.value
        } else {
            parsedOptionValue = parseInt(option.value)
        }
        if ((filterName === "regions" || filterName === "companyRegions") && savedSearchProfile[filterName].includes(parsedOptionValue)) {
            option.active = true
        }
        if ((filterName !== "regions" || filterName !== "companyRegions") && savedSearchProfile[filterName].includes(parsedOptionValue)) {
            option.active = true
        }
        if (child != null) {
            let updatedChildren = []
            let activeChilds = []
            option[child].map(function (item, index) {
                let parsedItemValue = ''
                if ((filterName === "regions" || filterName === "companyRegions")) {
                    parsedItemValue = item.value.split(",")
                } else {
                    parsedItemValue = parseInt(item.value)
                }
                if ((filterName === "regions" || filterName === "companyRegions")) {
                    parsedItemValue.map(function (parsedItem, index) {
                        if (savedSearchProfile[filterName].includes(parsedItem)) {
                            item.active = true
                        }
                    })

                } else {
                    if (savedSearchProfile[filterName].includes(parsedItemValue)) {
                        item.active = true
                    }
                }
                activeChilds.push(item.active)
                updatedChildren.push(item)
            })
            if (activeChilds.every(element => element === true) && option.display) {
                option.active = true
                option.isChildSelected = false
            } else if (activeChilds.every(element => element === false)) {
                option.isChildSelected = false
            } else {
                option.active = false
                option.isChildSelected = true
            }
            option[child] = updatedChildren
        }
        filteredList.push(option)
    })
    let itemsFilter = {
        ...filter,
        options: filteredList,
        active: true
    }
    if ((filterName !== "regions" || filterName !== "companyRegions")) {
        itemsFilter.isAllSelected = filteredList.every(child => child.active)
    }
    return itemsFilter
}

function updateFilterRecursively(stateDefaultFilter, savedSearchProfile, filterName) {
    let filter = _.cloneDeep(stateDefaultFilter[filterName])
    let stages = savedSearchProfile.material;
    let filteredList = []
    filter.options.map(fLevel => {
        if (stages.includes(fLevel.value)) {
            fLevel.active = true
            fLevel.subParent.map(sLevel => {
                sLevel.active = true;
                sLevel.children.map(tLevel => {
                    tLevel.active = true
                })
            })
        } else {
            fLevel.subParent.map(sLevel => {
                if (stages.includes(sLevel.value)) {
                    sLevel.active = true
                    sLevel.children.map(tLevel => {
                        tLevel.active = true
                    })
                } else {
                    sLevel.children.map(tLevel => {
                        if (stages.includes(tLevel.value)) {
                            tLevel.active = true
                        }
                    })
                }
                if (sLevel.children.every(child => child.active)) {
                    sLevel.active = true
                    sLevel.isChildSelected = false
                } else if (sLevel.children.every(child => !child.active)) {
                    sLevel.active = false
                    sLevel.isChildSelected = false
                } else {
                    sLevel.active = false
                    sLevel.isChildSelected = true
                }
            })
        }
        if (fLevel.subParent.every(sLevel => sLevel.active)) {
            fLevel.active = true
            fLevel.isChildSelected = false
        } else if (fLevel.subParent.some(sLevel => sLevel.isChildSelected)) {
            fLevel.active = false
            fLevel.isChildSelected = true
        } else if (fLevel.subParent.every(sLevel => !sLevel.active)) {
            fLevel.active = false
            fLevel.isChildSelected = false
        } else {
            fLevel.active = false
            fLevel.isChildSelected = true
        }
        filteredList.push(fLevel)
    })
    return {
        ...filter,
        active: true,
        isAllSelected: filteredList.every(child => child.active)
    }
}

function updateSaveSearchRoleFilter(stateDefaultFilter, savedSearchProfile, filterName) {
    let filter = stateDefaultFilter[filterName]
    let rolesFilter = {
        ...filter,
        options: filter?.options?.map(option => (savedSearchProfile[filterName].includes(parseInt(option.value))) ? { ...option, active: true } : { ...option, active: false }),
        active: true
    }
    rolesFilter.isAllSelected = rolesFilter?.options?.every(child => child.active)
    return rolesFilter
}

function updateSaveSearchArrayFilter(stateDefaultFilter, savedSearchProfile, filterName) {
    let filter = _.cloneDeep(stateDefaultFilter[filterName])
    return {
        ...filter,
        options: filter.options.map(option => applyStageFilter(option, savedSearchProfile[filterName])),
        active: true
    }
}

function applyStageFilter(option, stages) {
    if (option.children) {
        for (let subStage = 0; subStage < option.children.length; subStage++) {
            applyStageFilter(option.children[subStage], stages);
        }
    }
    let valArr = Array.isArray(option.value) ? option.value : [option.value];
    if (stages.filter(x => valArr.includes(x)).length == valArr.length) {
        option.active = true
    } else {
        option.active = false
    }
    return option
}

function updateParentStages(stageFilter, stagesArr) {
    stageFilter.options.map(parentStage => {
        if (stagesArr.includes(parentStage.value)) {
            parentStage.active = true
            parentStage.children.map(tLevel => {
                tLevel.active = true
            }
            )
        } else {
            parentStage.children.map(tLevel => {
                if (stagesArr.includes(tLevel.value)) {
                    tLevel.active = true
                }
            }
            )
        }
        if (parentStage.children.every(child => child.active)) {
            parentStage.active = true
            parentStage.isChildSelected = false
        } else if (parentStage.children.every(child => !child.active)) {
            parentStage.active = false
            parentStage.isChildSelected = false
        } else {
            parentStage.active = false
            parentStage.isChildSelected = true
        }
    })
    stageFilter.isAllSelected = stageFilter.options.every(child => child.active)
    return stageFilter
}

function updateMeasure(filter, savedSearchProfile, dispatch) {
    let from = "";
    let to = ""
    if (savedSearchProfile.operator && (savedSearchProfile.operator === "<=" || savedSearchProfile.operator === "<")) {
        to = savedSearchProfile.value
    } else if (savedSearchProfile.operator && (savedSearchProfile.operator === ">=" || savedSearchProfile.operator === ">")) {
        from = savedSearchProfile.value
    } else if (savedSearchProfile.operator && savedSearchProfile.operator === "..") {
        from = savedSearchProfile.value1
        to = savedSearchProfile.value2
    }
    let payload = {
        [filter]: {
            from: from,
            to: to,
            active: from || to ? true : false
        }
    }
    dispatch(updateMeasures(payload))
}